/* Note: This is an autogenerated file. Please DO NOT modify anything manually here. */
import * as Types from "src/generated/graph-api";

import { gql } from "@apollo/client";
export type GQLAccountSettingsBrokerageInfosFormFieldsFragment = {
	__typename: "IdentityTeam";
	brokerage: {
		__typename: "IdentityBrokerage";
		name: string | null;
		id: string;
		licenseNumber: string | null;
		licenseExpiration: string | null;
		phoneNumber: string | null;
		address: {
			__typename: "IdentityAddress";
			city: string | null;
			id: string;
			postalCode: string | null;
			street1: string | null;
			street2: string | null;
			state: string | null;
		} | null;
		managingBroker: {
			__typename: "IdentityBroker";
			id: string;
			email: string | null;
			phoneNumber: string | null;
			user: {
				__typename: "IdentityBrokerUser";
				id: string;
				firstName: string | null;
				lastName: string | null;
				displayName: string | null;
			} | null;
			license: {
				__typename: "IdentityLicense";
				id: string;
				expiration: string | null;
				number: string | null;
				state: {
					__typename: "IdentitySupportedState";
					name: string;
					code: Types.GQLIdentitySupportedStateCode;
				} | null;
			} | null;
		} | null;
	} | null;
	supervisingBroker: {
		__typename: "IdentityBroker";
		id: string;
		user: {
			__typename: "IdentityBrokerUser";
			id: string;
			firstName: string | null;
			lastName: string | null;
		} | null;
		license: {
			__typename: "IdentityLicense";
			id: string;
			number: string | null;
			expiration: string | null;
			state: { __typename: "IdentitySupportedState"; name: string } | null;
		} | null;
	} | null;
};

export const AccountSettingsBrokerageInfosFormFieldsFragmentDoc = gql`
    fragment AccountSettingsBrokerageInfosFormFields on IdentityTeam {
  brokerage {
    name
    id
    licenseNumber
    licenseExpiration
    phoneNumber
    address {
      city
      id
      postalCode
      street1
      street2
      state
    }
    managingBroker {
      id
      user {
        id
        firstName
        lastName
        displayName
      }
      email
      phoneNumber
      license {
        id
        expiration
        state {
          name
          code
        }
        number
      }
    }
  }
  supervisingBroker {
    id
    user {
      id
      firstName
      lastName
    }
    license {
      id
      number
      state {
        name
      }
      expiration
    }
  }
}
    `;
